import { render, staticRenderFns } from "./AppraisalResponseCardHistory.vue?vue&type=template&id=496a5b2c&"
import script from "./AppraisalResponseCardHistory.vue?vue&type=script&lang=ts&"
export * from "./AppraisalResponseCardHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemSubtitle})
